import React from 'react'
import { Container } from 'react-bootstrap'
import Heading from "../ui/Heading";
import Slider from "react-slick";
import Img2 from "../Assets/img/manuelExprience-1.svg"
import Img1 from "../Assets/img/manuelExprience-2.svg"
import Img3 from "../Assets/img/manuelExprience-3.svg"
import Img4 from "../Assets/img/manuelExprience-4.svg"
import { useTranslation } from 'react-i18next'
export default function ManuelExprience() {
 const { t } = useTranslation();
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [

            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

const boxes = [
    { image: Img1, alt: "Image one", key: 'extExperience' },
    { image: Img2, alt: "Image two", key: 'customJewelty' },
    { image: Img3, alt: "Image three", key: 'lowPrice' },
    { image: Img4, alt: "Image four", key: 'topQuality' }
  ];
    return (
        <section className="section-space pb-lg-0">
            <Container className="manuel_exprience_section">
                <Heading>
                    <h2>{t('manuelExperience.heading')}</h2>
                    <p> {t('manuelExperience.subheading')} </p>
                </Heading>

                <div className="manuel_exprience_container">
                    <Slider {...settings}>
                        {boxes.map((box, index) => (
                            <div className="manuel_exprience_box" key={index}>
                                <img src={box.image} loading="lazy" alt={box.alt} className="d-block mx-auto" />
                                <h2 dangerouslySetInnerHTML={{ __html: t(`manuelExperience.${box.key}`) }} />
                            </div>
                        ))}
                    </Slider>
                </div>
            </Container>
        </section>
    )
}
